// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2357":"e79b4574","6249":"e0d6aeb4","8089":"e79b4574"}[chunkId] + ".chunk.css";
};